export const translations = {
  COMMON: {
    ABOUT: 'common.about.headline',
    ACTIVE: 'common.active',
    ADD: 'common.add',
    ADMIN: 'common.admin',
    ADVANCED: 'common.advanced',
    ACCEPT: 'common.accept',
    ALL: 'common.all',
    AND_THE: 'common.andThe',
    ASK_LIFE_PROOF: 'common.askLifeProof',
    AUDIT: 'common.audit',
    AUTOGRAPH: 'common.autograph',
    TYPED: 'common.typed',
    BACK: 'common.back',
    BLOCKCHAIN_PROCESSING: 'common.blockchainProcessing',
    SIGNED_LEGACY: 'common.signed',
    PARTIALLY_SIGNED_LEGACY: 'common.partiallySigned',
    UNSIGNED_LEGACY: 'common.unsigned',
    CANCEL: 'common.cancel',
    CERTIFICATE_TYPE: 'common.certificateType',
    CATEGORIES: 'common.categories',
    CHANGE: 'common.change',
    CINCEL_TITLE: 'common.cincelTitle',
    COMMENTS: 'common.comments',
    CONTINUE: 'common.continue',
    CREATE: 'common.create',
    DATE: 'common.date',
    DELETE_DOCUMENT: 'common.deleteDocument',
    DELETE: 'common.delete',
    DESCRIPTION: 'common.description',
    DETAIL: 'common.detail',
    DOWNLOAD: 'common.download',
    DRAG_FILE: 'common.dragFile',
    EDIT: 'common.edit',
    EMAIL: 'common.email',
    ENGLISH: 'common.english',
    FILE: 'common.file',
    GOOGLE_LOGIN: 'common.googleLogin',
    HISTORY: 'common.history',
    I_ACCEPT: 'common.iAccept',
    INACTIVE: 'common.inactive',
    INVITEE: 'common.invitee',
    LOAD_MORE: 'common.loadMore',
    LOGIN: 'common.login',
    LOGOUT: 'common.logout',
    MORE_INFO: 'common.moreInfo',
    NEW_STAGE: 'common.newStage',
    NO_DOCUMENTS: 'common.noDocuments',
    NO_SELECTED_FILES: 'common.noSelectedFiles',
    NO_SIGN: 'common.noSign',
    OBTAIN: 'common.obtain',
    OWNER: 'common.owner',
    PARTIALLY_SIGNED: 'common.partiallySigned',
    PRIVACY_POLICY: 'common.privacyPolicy',
    PROFILE: 'common.profile',
    QUOTE: 'common.quote',
    RECOMMENDED_DIMENSIONS: 'common.recommendedDimensions',
    REGISTER: 'common.register',
    REJECT: 'common.reject',
    SAVE: 'common.save',
    SEARCH: 'common.search',
    SERACH_BY_NAME: 'common.searchByName',
    SEND: 'common.send',
    SEND_REMINDER: 'common.sendReminder',
    SHARE: 'common.share',
    SIGN_UP: 'common.signUp',
    SIGN: 'common.sign',
    SIGNATURE_TYPE: 'common.signatureType',
    SIGNED: 'common.signed',
    SIGNER: 'common.signer',
    SIGNERS: 'common.signers',
    SPANISH: 'common.spanish',
    STAGE: 'common.stage',
    STARTED: 'common.createdAt',
    STATUS: 'common.status',
    STORE_PASSWORD: 'common.storePassword',
    SUCCESSFULLY: 'common.successfully',
    TERMS: 'common.terms',
    UNSIGNED: 'common.unsigned',
    UPDATE: 'common.update',
    USE_ORGANIZATION: 'common.useOrganization',
    VALIDATE: 'common.validate',
    WANT_TO_CONTINUE: 'common.wantToContinue',
    YES: 'common.yes',
    NO: 'common.no',
    GEOLOCATION: 'common.geolocation',
    OPTIONAL: 'common.optional',
    REQUIRED: 'common.required',
    OBSERVERS: 'common.observers',
    OBSERVER: 'common.observer',
    PREVIEW: 'common.preview',
    FORM_DATA: 'common.formData',
    SIGNER_INFORMATION: 'common.signerInformation',
    NAME: 'common.name',
    CREATED_AT: 'common.createdAt',
    FIELDS: 'common.fields',
    TABLE_HEADING_CREATED_AT: 'common.table.heading.createdAt',
    TABLE_HEADING_EMAIL: 'common.email',
    TABLE_HEADING_NAME: 'common.name',
    TABLE_HEADING_ROLE: 'common.table.heading.role',
    TABLE_HEADING_STATUS: 'common.table.heading.status',
    TABLE_HEADING_UPDATED_AT: 'common.table.heading.updatedAt',
    SUCCESS: {
      CREATED: 'common.success.created',
      UPDATED: 'common.success.updated',
      DELETED: 'common.success.deleted',
      SAVED: 'common.success.saved',
    },
    FEATURE_MODAL_TITLE: 'common.featureModal.title',
    FEATURE_MODAL_BODY: 'common.featureModal.body',
    FEATURE_MODAL_SUBMIT: 'common.featureModal.submit',
    SUBMIT: 'common.send',
    BRANDING_MOVED_MSG: 'common.brandingMovedMsg',
    BRANDING_MOVED_TITLE: 'common.brandingMovedTitle',
    GO_TO_BRANDING: 'common.goToBranding',
    TYPED_SIGNATURE_LEGEND: 'common.typedSignatureLegend',
    EFIRMA_SIGNATURE_LEGEND: 'efirmaLegend',
    AUTOGRAPH_SIGNATURE_LEGEND: 'common.autographSignatureLegend',
    ABOUT_BANNER: 'common.about.banner',
    ABOUT_TAGLINE: 'common.about.tagline',
    AND: 'common.and',
    VALIDATE_RFC: 'common.validateRFC',
    ENTER_EXPECTED_RFC: 'common.enterExpectedRFC',
    VERIFY_RFC_VS_FEA: 'common.verifyRfcVsFea',
    TOOLTIP_ABOUT_RFC_VALIDATION: 'common.rfcValidationTooltip',
    RFC: 'common.rfc',
    CURP: 'common.curp',
    CLOSE: 'common.close',
  },
  CONTACTS: {
    ADD_TITLE: 'contacts.addTitle',
    BUTTON_ADD: 'contacts.buttonAdd',
    CSV_HELPER: 'contacts.csvHelper',
    CSV_TITLE: 'contacts.csvTitle',
    DELETE_SUCCESS: 'common.success.deleted',
    STATUS_CODE_409: 'contacts.statusCode409',
    HEADING: 'contacts.heading',
    PATCH_SUCCESS: 'common.success.updated',
    POST_SUCCESS: 'common.success.created',
    SUBHEADING: 'contacts.subHeading',
    TABLE_EMPTY: 'contacts.table.empty',
    UPDATE_TITLE: 'contacts.updateTitle',
    UPLOAD_CSV: 'contacts.uploadCsv',
  },
  INBOX: {
    TITLE: 'inbox.title',
    SUB_TITLE_IN_PROGRESS: 'inbox.subTitle.unsignedAndSigner',
    SUB_TITLE_SIGNED: 'inbox.subTitle.signedAndSigner',
    SUB_TITLE_ONLY_TO_WATCH: 'inbox.subTitle.onlyToWatch',
    SUB_TITLE_ALL: 'inbox.subTitle.allDocuments',
    CREATE_DOCUMENT_BUTTON: 'sidebar.createDocument',
    OTHERS: 'inbox.others',
  },
  INPUTS: {
    HELPER_TEXT: 'inputs.helperText',
    NEW_FORM: 'inputs.newForm',
    CONFIRM_PASSWORD: 'inputs.confirmPassword',
    DOCUMENT_CHECKBOX: 'inputs.documentCheckbox',
    DOCUMENT_NAME: 'inputs.documentName',
    DONT_SHOW_AGAIN: 'common.dontShowAgain',
    EMAIL: 'common.email',
    ENTER_EMAIL: 'inputs.enterEmail',
    FOLDER_NAME: 'inputs.folders.name',
    NAME: 'inputs.name',
    NEW_ORGANIZATION_INPUT: 'inputs.newOrganization.input',
    NEW_ORGANIZATION_LABEL: 'inputs.newOrganization.label',
    NEW_PASSWORD: 'inputs.newPassword',
    PASSWORD_KEY: 'inputs.passwordKey',
    PASSWORD: 'inputs.password',
    REWARDS_AVAILABILITY: 'inputs.rewardsAvailability',
    SELECT_FOLDER: 'inputs.selectFolder',
    SELECT_LANGUAGE: 'inputs.selectLanguage',
    TEXT_FIELD_FORM_DEFAULT_VALUE: 'inputs.textFieldForm.defaultValue',
    TEXT_FIELD_FORM_FIELD_FLAGS_MULTILINE:
      'inputs.textFieldForm.fieldFlags.multiLine',
    TEXT_FIELD_FORM_FIELD_FLAGS_READ_ONLY:
      'inputs.textFieldForm.fieldFlags.readOnly',
    TEXT_FIELD_FORM_FIELD_FLAGS_REQUIRED:
      'inputs.textFieldForm.fieldFlags.required',
    TEXT_FIELD_FORM_FIELD_FLAGS_TITLE: 'inputs.textFieldForm.fieldFlags.title',
    TEXT_FIELD_FORM_FIELD_NAME: 'inputs.textFieldForm.fieldName',
    VERIFICATION_CODE_LABEL: 'inputs.verificationCode',
    SELECT_FORM: 'inputs.selectForm',
    SIGNER_INFORMATION: 'inputs.signerInformation',
    FORM_FILL: 'inputs.formFill',
    FORM_VALIDATE: 'inputs.formValidate',
    ROLE: 'inputs.role',
    DOCUMENT_NOTIFICATION: 'inputs.notification',
    SHOW_CERTIFICATE_PII: 'inputs.showCertificatePii',
    FORCE_SIGNER_GEOLOCATION: 'inputs.forceSignerGeolocation',
  },
  ERRORS: {
    AT_LEAST_CHOOSE_ONE_ITEM: 'errors.atLeastChooseOneItem',
    MAX_ITEMS_ALLOWED_3: 'errors.maxItemsAllowed3',
    MAX_LENGTH_50: 'errors.maxLength50',
    MAX_LENGTH_100: 'errors.maxLength100',
    MAX_LENGTH_144: 'errors.maxLength144',
    MAX_LENGTH_255: 'errors.maxLength255',
    MAX_LENGTH_1000: 'errors.maxLength1000',
    FORM_NAME_REQUIRED: 'errors.forms.nameRequired',
    FORM_NAME_MAX_50: 'errors.forms.max50',
    BLOCKCHAIN_ERROR: 'errors.blockchainError',
    CONFIRM_PASSWORD: 'errors.confirmPassword',
    CREATE_DOCUMENT_ANNOTATION_ERROR: 'errors.createDocument.annotationError',
    CREATOR_OUT_LIFE_PROOF: 'errors.creatorOutLifeProof',
    DOCUMENT_FOLDER_REQUIRED: 'errors.documentFolderRequired',
    DOCUMENT_NAME_REQUIRED: 'errors.documentNameRequired',
    DOCUMENT_DESCRIPTION_REQUIRED: 'errors.documentDescriptionRequired',
    DOCUMENT_SIZE: 'errors.documentSize',
    EXISTING_SIGNATURE_FIELD: 'errors.existingSignatureField',
    GENERAL_EXISTING_SIGNATURE_FIELD: 'errors.generalExistingSignatureField',
    GENERAL_ERROR: 'errors.general',
    HASH_ERROR: 'errors.hashError',
    IMAGE_512: 'errors.image512',
    IMAGE_FORMAT: 'errors.imageFormat',
    IMAGE_SIZE: 'errors.imageSize',
    LIFE_PROOF_MAX_TRIES: 'errors.lifeProofMaxTries',
    LOGIN_UNSUCCESFUL: 'errors.loginUnsuccesful',
    MAX_FILE_SIZE: 'errors.maxFileSize',
    NETWORK_DEFAULT: 'errors.network.default',
    NO_BASIC_CERTIFICATES: 'errors.noBasicCertificates',
    NO_SMART_CERTIFICATES: 'errors.noSmartCertificates',
    NOM_ERROR: 'errors.nomError',
    ONLY_PNG_FILES: 'errors.onlyPngFiles',
    ONLY_CSV_FILES: 'errors.onlyCsvFiles',
    ONLY_POSITIVE_NUMBERS: 'errors.onlyPositiveNumbers',
    OUT_OF_SERVICE: 'errors.outOfService',
    PASSWORD_LENGTH: 'errors.passwordLength',
    PASSWORDS_DONT_MATCH: 'errors.passwordsDontMatch',
    PDF_SIGNATURE_CANT_ADD_SIGN: 'errors.pdfSignatureCantAddSign',
    PDF_SIGNATURE_ERROR: 'errors.pdfSignatureError',
    PDF_SIGNATURE_GENERAL: 'errors.pdfSignatureGeneral',
    PDF_SIGNATURE_UPDATE_ERROR: 'errors.pdfSignatureUpdateError',
    PKCS7: 'errors.pkcs7',
    REQUIRED: 'errors.required',
    REQUIRED_EMAIL: 'errors.requiredEmail',
    REQUIRED_NAME: 'errors.requiredName',
    REQUIRED_PASSWORD: 'errors.requiredPassword',
    REQUIRED_VERIFICATION_CODE: 'errors.requiredVerificationCode',
    RESTORE_PASSWORD_ERROR: 'errors.restorePasswordError',
    // LEGACY SEGURIDATA KEYS
    SEGURIDATA_CIN01: 'errors.seguridata.cin01',
    SEGURIDATA_CIN02: 'errors.seguridata.cin02',
    SEGURIDATA_CIN03: 'errors.seguridata.cin03',
    SEGURIDATA_CIN06: 'errors.seguridata.cin06',
    SEGURIDATA_CIN09: 'errors.seguridata.cin09',
    SIGNATURE_ERROR: 'errors.signatureError',
    SIGNUP_ALREADY_REGISTERED: 'errors.signup.alreadyRegistered',
    STORAGE_LIMIT: 'errors.storageLimit',
    USER_NOT_FOUND: 'errors.users.notFound',
    VALID_EMAIL_CHARACTERS: 'errors.validEmailCharacters',
    VALID_EMAIL: 'errors.validEmail',
    VALID_URL: 'errors.validUrl',
    VERIFICATION_CODE_MAX_DIGITS_ERROR: 'errors.verificationCodeMaxDigits',
    VERIFICATION_CODE_REQUEST_ERROR: 'errors.confirmation.errorWhileSending',
    WHITELABEL_401: 'errors.whitelabel.401',
    WHITELABEL_402: 'errors.whitelabel.402',
    WHITELABEL_404: 'errors.whitelabel.404',
    WHITELABEL_413: 'errors.whitelabel.413',
    WHITELABEL_415: 'errors.whitelabel.415',
    WHITELABEL_500: 'errors.whitelabel.500',
    INVITATIONS_ERROR: 'errors.invitations',
    GENERAL_MIN_LENGTH: 'errors.general.minLength',
    GENERAL_MAX_LENGTH: 'errors.general.maxLength',
    GENERAL_REQUIRED: 'errors.general.required',
    NO_TEMPLATE_FIELDS: 'errors.formTemplates.noFields',
    NO_PDF: 'errors.formTemplates.noPdf',
    FORM_TEMPLATE_UPDATE_ERROR: 'errors.formTemplates.update',
    FORM_TEMPLATE_CREATE_ERROR: 'errors.formTemplates.create',
    FORM_TEMPLATE_DELETE_ERROR: 'errors.formTemplates.delete',
    EXISTING_EMAIL: 'errors.general.existingEmail',
    FORM_CREATED: 'error.forms.create',
    FORM_FILLED: 'error.forms.filled',
    NO_CERITIFICATES_AVAILABLE: 'errors.noCertificatesAvailable',
    PERMISSIONS: 'errors.permissions',
    NOT_ENOUGH_CREDITS: 'errors.notEnoughCredits',
    NETWORK_ERROR: 'errors.networkError',
    ERROR_500: 'errors.http.500.unexpected',
    ERROR_501: 'errors.http.501.not_implemented',
    ERROR_502: 'errors.http.502.bad_gateway',
    ERROR_503: 'errors.http.503.service_unavailable',
    ERROR_504: 'errors.http.504.gateway_timeout',
    REQUIRED_FIELD: 'errors.required',
  },
  SUCCESS: {
    DOCUMENT_DELETED: 'folders.documentDeleted',
    DOCUMENT_FOLDER_CHANGED: 'success.folders.documentFolderChanged',
    DOCUMENT_SIGNED: 'success.documentSigned',
    FOLDERS_CREATED: 'common.success.created',
    FOLDERS_DELETE: 'common.success.deleted',
    FOLDERS_EDITED: 'common.success.updated',
    LIFE_PROOF_SUCCESS: 'success.lifeProofSuccess',
    ORGANIZATION_CREATED: 'common.success.created',
    ORGANIZATION_EDITED: 'common.success.updated',
    ORGANIZATION_INVITATION_DELETED: 'common.success.deleted',
    ORGANIZATION_INVITATION_SENT: 'success.organizationInvitationSent',
    ORGANIZATION_USER_DELETED: 'common.success.deleted',
    PROFILE_EDITED: 'common.success.updated',
    REMINDER_SENT: 'success.reminderSent',
    RESET_PASSWORD_SENT: 'success.resetPassword.sent',
    RESET_PASSWORD_SUCCESS: 'success.ressetPassword.success',
    SIGNUP_SUCCESS: 'success.signup.message',
    WHITELABEL_200: 'common.success.updated',
    INVITATION_CREATED_OBSERVER: 'success.invitationCreated.observer',
    INVITATION_UPDATED_OBSERVER: 'success.updatedCreated.observer',
    INVITATION_DELETED_OBSERVER: 'success.deletedCreated.observer',
    INVITATION_CREATED_SIGNER: 'success.invitationCreated.signer',
    INVITATION_UPDATED_SIGNER: 'common.success.created',
    INVITATION_DELETED_SIGNER: 'success.deletedCreated.signer',
    FORM_TEMPLATE_UPDATE_SUCCESS: 'success.formTemplates.update',
    FORM_TEMPLATE_CREATE_ERROR: 'success.formTemplates.create',
    FORM_CREATED: 'succss.forms.create',
    FORM_FILLED: 'success.forms.filled',
    FORM_FILLED_UNREGISTERED_USER: 'success.forms.filledUnregisteredUser',
  },
  MODALS: {
    ADD_FROM_CONTACTS: 'modals.addFromContacts',
    ADD_FROM_NAME_AND_EMAIL: 'modals.AddFromNameAndEmail',
    ADD_OBSERVER_TITLE: 'modals.observer.createTitle',
    ADD_SIGNER_TO_DIRECTORY: 'modals.addSignerToDirectory',
    ADD_USER: 'modals.addUser',
    CHOOSE_SIGNERS: 'modals.chooseSigners',
    EDIT_OBSERVER_TITLE: 'modals.observer.editTitle',
    EDIT_USER: 'modals.editUser',
    NEW_FORM: 'modals.newForm',
    CHANGE_FOLDER_TITLE: 'folders.changeFolder',
    DELETE_DOCUMENT_MESSAGE: 'modals.deleteDocument.message',
    DELETE_DOCUMENT_TITLE: 'common.deleteDocument',
    DELETE_FOLDER: 'modals.folders.deleteFolder',
    DOCUMENT_CREATED_SUCCESS: 'modals.documentCreated.message',
    EDIT_FOLDER: 'modals.folders.editFolder',
    EXISTING_ANNOTATIONS: 'modals.existingAnnotations.title',
    LIFE_PROOF_CLOSING: 'modals.lifeProof.closing',
    LIFE_PROOF_MESSAGE: 'modals.lifeProof.message',
    LIFE_PROOF_TITLE: 'modals.lifeProof.title',
    LIFE_PROOF_VALIDATING: 'modals.lifeProof.validating',
    NEW_FOLDER: 'modals.folders.newFolder',
    NEW_STAGE_NAME: 'modals.newStage.name',
    NEW_STAGE_SUBTITLE: 'modals.newStage.subTitle',
    NEW_STAGE_TITLE: 'modals.newStage.title',
    ORGANIZATION_INVITATION: 'modals.organization.invitation',
    PDF_CONVERT_MESSAGE: 'modals.pdfConvert.message',
    PDF_CONVERT_TITLE: 'modals.pdfConvert.title',
    SIGNATURE_TITLE: 'modals.signatureTitle.title',
    SIGNER_ASK_DOCUMENTS: 'modals.signer.askDocuments',
    SIGNER_ASK_LIFE_PROOF: 'modals.signer.askFileProof',
    SIGNER_DOCUMENT: 'modals.signer.document',
    SIGNER_TITLE_ADD: 'contacts.buttonAdd',
    SIGNER_TITLE_MODIFY: 'modals.signer.titleModify',
    NO_CREDIT_TO_CREATE_DOCUMENT:
      'modals.document.no_credit_to_create_document',
    NO_CREDIT_TO_CREATE_DOCUMENT_TITLE:
      'modals.document.no_credit_to_create_document_title',
    NO_CREDIT_TO_CREATE_DOCUMENT_CLOSE: 'common.close',
    ADD_SIGNER_NOTIFICATION: 'modals.document.add_signer_notification',
  },
  // COMPONENTS
  USER_DROPDOWN: {
    INVITATION_ACCEPTED: 'userDropdown.invitationAcepted',
    INVITATION_EMPTY: 'userDropdown.invitationEmpty',
    INVITATION_MESSAGE: 'userDropdown.invitationMessage',
    INVITATION_REJECTED: 'userDropdown.invitationRejected',
  },
  DROPZONE: {
    RECOMMENDED_SIZE: 'dropzone.recommendedSize',
    VALID_FILES: 'dropzone.validFiles',
  },
  SIDEBAR: {
    CREATE_DOCUMENT: 'sidebar.createDocument',
    NOTIFICATIONS: 'sidebar.notifications',
    CONTACTS: 'common.signers',
    FAQ: 'sidebar.faqs',
    FOLDERS: 'sidebar.folders',
    FORMS: 'forms.title',
    GUIDES: 'sidebar.guides',
    HELP_CENTER: 'sidebar.helpCenter',
    INBOX: 'inbox.title',
    INBOX_IN_PROGRESS: 'sidebar.inboxInProgress',
    INBOX_SIGNED: 'inbox.signed',
    INBOX_INVITED_TO_WATCH: 'sidebar.inboxInvitedToWatch',
    INBOX_ALL: 'common.all',
    INSURANCE: 'sidebar.insurance',
    INTEGRATIONS: 'integrations.title',
    MANIFESTO: 'sidebar.manifesto',
    MARKETING: 'admin.title',
    MARKETING_REWARDS: 'sidebar.rewardAdmin',
    ORGANIZATIONS: 'organizations.title',
    REWARDS: 'rewards.title',
    SUBS_CERT_BASIC: 'sidebar.certBasic',
    SUBS_CERT_SMART: 'creditTypes.docs',
    SUBS_PLAN: 'sidebar.plan',
    SUBS_PROOF: 'sidebar.proof',
    SUBS_STORAGE: 'sidebar.storage',
    SUBS_USERS: 'sidebar.users',
    SUPPORT: 'sidebar.support',
    VERIFICATION: 'sidebar.verification',
  },
  GUEST_LOGIN: {
    GREETING: 'guestLogin.greeting',
    CONFIRM_MESSAGE: 'guestLogin.confirmMessage',
    SEND_CODE: 'guestLogin.sendCode',
    SENDING: 'guestLogin.sending',
    CODE_SENT_TITLE: 'guestLogin.codeSentTitle',
    CODE_SENT_DESCRIPTION: 'guestLogin.codeSentDescription',
    OTP_MESSAGE: 'guestLogin.otpMessage',
    RETRY: 'guestLogin.retry',
    VERIFYING: 'guestLogin.verifying',
  },
  PAGINATION: {
    RESULTS: 'pagination.results',
    SHOW: 'pagination.show',
  },
  CERTIFICATE_TYPES: {
    BASIC: 'certificateType.basic',
    BASIC_TEXT: 'certificateType.basicText',
    CHOOSE_CERTIFICATE: 'certificateType.chooseCertificate',
    INCLUDES: 'certificateType.includes',
    SMART: 'certificateType.smart',
    SMART_TEXT_ADOBE: 'certificateType.smartTextAdobe',
    SMART_TEXT_BITCOIN: 'certificateType.smartTextBitcoin',
    SMART_TEXT_NOM: 'certificateType.smartTextNom',
    SMART_TEXT_VERIFICATION: 'certificateType.smartTextVerification',
  },
  // PAGES
  AUTH_PAGES: {
    LOGIN_OTP_INSTRUCTIONS: 'login.otpInstructions',
    CONFIRM_ACCOUNT_TITLE: 'confirmAccount.title',
    LOGIN_FORGOT_PASSWORD: 'login.forgotPassword',
    LOGIN_NO_ACCOUNT: 'login.noAccount',
    LOGIN_SEND_CODE: 'login.sendCode',
    LOGIN_USE_PASSWORD: 'login.usePassword',
    LOGIN_SEND_OTP: 'login.sendOtp',
    LOGIN_SENDING: 'login.sending',
    LOGIN_SUCCESSFUL: 'login.success',
    LOGIN_REGISTER_FREE: 'login.registerFree',
    LOGIN_TITLE: 'login.title',
    RESET_PASSWORD_SUCCESS_SUBTITLE: 'resetPasswordSuccess.subtitle',
    RESET_PASSWORD_SUCCESS_TITLE: 'resetPasswordSuccess.title',
    RESET_PASSWORD_TITLE: 'resetPassword.title',
    REQUEST_NEW_CODE: 'request.code',
    SIGNUP_CERTIFICATES: 'signup.certificates',
    SIGNUP_CLICK: 'signup.click',
    SIGNUP_FINGERPRINTS: 'signup.fingerprints',
    SIGNUP_FREEPLAN_TITLE: 'signup.freeplanTitle',
    SIGNUP_FUNCTIONS: 'signup.functions',
    SIGNUP_HAVE_ACCOUNT: 'signup.haveAccount',
    SIGNUP_INTEGRATIONS: 'signup.integrations',
    SIGNUP_ISO: 'signup.iso',
    SIGNUP_LOGIN_HERE: 'signup.loginHere',
    SIGNUP_NOTARIZATION: 'signup.notarization',
    SIGNUP_SIGN: 'signup.sign',
    SIGNUP_TITLE: 'signup.title',
    VERIFICATION_CODE_SUCCESS_SENT: 'success.confirmation.emailSent',
    VERIFICATION_CODE_ERROR_TOAST: 'verificationCode.errorToast',
    VERIFICATION_CODE_MANY_ERROR_TOAST: 'verificationCode.errorManyToast',
    VERIFICATION_CODE_SUCCESS_TOAST: 'verificationCode.successToast',
    LEGAL_WARNING: 'auth.legalWarning',
    NO_CODE: 'auth.noCode',
  },
  DOCUMENT_PAGES: {
    CANT_SEND_MESSAGE: 'signDocument.cantSendMessage',
    CREATE_DOCUMENT_INVITATION_MESSAGE: 'createDocument.invitationMessage',
    CREATE_DOCUMENT_NO_NAME: 'createDocument.noName',
    CREATE_DOCUMENT_TITLE: 'createDocument.title',
    CREATE_DOCUMENT_VALID_FILES: 'createDocument.validFiles',
    DOCUMENT_VIEWPORT_GEO: 'documentViewport.geo',
    ENTER_CER: 'signDocument.enterCer',
    ENTER_KEY: 'signDocument.enterKey',
    EXISTING_ANNOTATIONS: 'existingAnnotations.message',
    HISTORY_INACTIVE: 'signDocument.historyInactive',
    HISTORY_NEW_VERSION: 'signDocument.historyNewVersion',
    HISTORY_SIGNED: 'signDocument.historySigned',
    NEW_COLOR: 'createDocument.newColor',
    NO_SIGNS: 'signDocument.noSigns',
    PARTIALLY_SIGNED: 'signDocument.partiallySign',
    SIGNATURE_TYPE: 'modals.signer.document',
    SIGNED: 'signDocument.signed',
    TOOLBAR_NO_SIGNERS: 'toolbar.noSigners',
    TOOLBAR_SIGN_CERTIFICATE_TYPE: 'toolbar.signCertificateType',
    WRITE_COMMENT: 'signDocument.writeComment',
    NO_OBSERVERS: 'createDocument.noObservers',
    NO_COMMENTS: 'signDocument.noComments',
    TEAM_FOLDER_DOCUMENTS_TITLE: 'team.folder.documents.title',
    TEAM_FOLDER_DOCUMENTS_SUB_TITLE: 'team.folder.documents.subTitle',
    TEAM_FOLDER_DOCUMENTS_CREATE_DOCUMENT_BUTTON:
      'team.folder.documents.createDocumentButton',
    STATUS_CODE_409: 'createDocument.statusCode409',
    STATUS_CODE_403: 'createDocument.statusCode403',
    STATUS_CODE_402: 'createDocument.statusCode402',
    SIGN_DOCUMENT_STATUS_CODE_403: 'signDocument.statusCode403',
    IDENTITY_VERIFICATION_STATUS_CODE_403: 'identityVerification.statusCode403',
    INVITE_DELETE_SUCCESS: 'signDocument.invite.deleteSuccess',
    INVITE_DELETE_403: 'signDocument.invite.delete403',
    INVITE_PATCH_SUCCESS: 'common.success.updated',
    INVITE_POST_SUCCESS: 'signDocument.invite.postSuccess',
    SIGNATURE_STATUS_CODE_409: 'signDocument.statusCode409',
    IDENTITY_FAILED: 'signDocument.identity.failed',
    IDENTITY_SUCCESS: 'signDocument.identity.success',
    DOCUMENT_IS_DELETED: 'signDocument.isDeleted',
    SUBTITLE: 'signDocument.subtitle',
    DOCUMENT_MORE_THAN_20MB: 'signDocument.moreThan20Mb',
    SIGN_MORE_THAN_20MB: 'signature.moreThan20Mb',
    POPOVER_STAGES: 'createDocument.popover.stages',
    POPOVER_FILE: 'createDocument.popover.file',
    POPOVER_ANNOTATIONS: 'createDocument.popover.annotations',
    INVITE_EXPIRED_HEADLINE: 'signDocument.invite.expired.headline',
    INVITE_EXPIRED_PRIMARY_ACTION: 'signDocument.invite.expired.primaryAction',
    INVITE_EXPIRED_TAGLINE: 'signDocument.invite.expired.tagline',
    LOADING_HEADLINE: 'signDocument.loading.headline',
    LOADING_TAGLINE: 'signDocument.loading.tagline',
    GEOLOCATION_TITLE: 'common.geolocation',
    GEOLOCATION_REQUIRED_MESSAGE: 'signDocument.geolocation.requiredMessage',
    GEOLOCATION_DENIED_MESSAGE: 'signDocument.geolocation.deniedMessage',
    GEOLOCATION_UNSTABLE_MESSAGE: 'signDocument.geolocation.unstableMessage',
    GEOLOCATION_UNKNOWN_MESSAGE: 'signDocument.geolocation.unknownMessage',
    GEOLOCATION_PERMISSION_PROMPT: 'signDocument.geolocation.permissionPrompt',
  },
  FOLDERS_PAGES: {
    CHANGE_FOLDER: 'folders.changeFolder',
    CONFIRMATION: 'folders.confirmation',
    GENERAL: 'folders.general',
    MY_FOLDERS: 'folders.myFolders',
    NEW_FOLDER: 'folders.newFolder',
    DELETE_SUCCESS: 'common.success.deleted',
    PATCH_SUCCESS: 'common.success.updated',
    POST_SUCCESS: 'common.success.created',
    SUB_HEADING: 'folders.subHeading',
    STATUS_CODE_409: 'folders.statusCode409',
    TABLE_EMPTY: 'folders.table.empty',
  },
  INTEGRATIONS: {
    TITLE: 'integrations.title',
  },
  REWARDS: {
    ADMIN_HEADING: 'sidebar.rewardAdmin',
    BENEFIT_LABEL: 'rewards.benefit.label',
    BUTTON_CREATE_REWARD: 'rewards.button.create',
    BUTTON_EDIT_REWARD: 'rewards.edit.heading',
    COMPANY_LOGO_LABEL: 'rewards.companyLogo.label',
    COMPANY_NAME_LABEL: 'rewards.companyName.label',
    COMPANY_SUMMARY_LABEL: 'rewards.companySummary.label',
    COUNTRIES_LABEL: 'rewards.countries.label',
    COUPON_LABEL: 'rewards.coupon.label',
    COVER_LABEL: 'rewards.cover.label',
    CREATE_SUCCESS: 'rewards.create.success',
    DELETE_SUCCESS: 'rewards.delete.success',
    DETAILS_LABEL: 'rewards.details.label',
    EDIT_HEADING: 'rewards.edit.heading',
    PRIORITY_LABEL: 'rewards.priority.label',
    TABLE_EMPTY: 'rewards.table.empty',
    TABLE_HEADING_COMPANY: 'common.company',
    TABLE_HEADING_CATEGORIES: 'common.categories',
    TABLE_HEADING_DATE: 'common.date',
    TABLE_HEADING_PRIORITY: 'rewards.priority.label',
    TABLE_HEADING_REWARD: 'rewards.table.heading.reward',
    TITLE: 'rewards.title',
    UPDATE_SUCCESS: 'rewards.update.success',
    URL_LABEL: 'rewards.url.label',
  },
  ORGANIZATIONS: {
    ACCEPT_MESSAGE: 'organizations.acceptMessage',
    ADD_NEW_USER: 'organizations.addNewUser',
    ADD_NEW_USER_HEADING: 'sidebar.users',
    ADD_NEW_USER_SUB_HEADING: 'organizations.addNewUserSubHeading',
    CREATE_TITLE: 'organizations.createTitle',
    CREATE_SUCCESS: 'common.success.created',
    CREATE_USER_SUCCESS: 'organizations.usersPostSuccess',
    DELETE_USER_SUCCESS: 'common.success.deleted',
    EDIT_ORGANIZATION: 'organizations.editOrganization',
    EDIT_ORGANIZATION_SUB_TITLE: 'organizations.editOrganizationSubTitle',
    EMPTY_TABLE: 'organizations.empty-table',
    LOGO: 'organizations.logo',
    MY_ORGANIZATION: 'organizations.myOrganization',
    NEW: 'organizations.new',
    ROLE: 'common.table.heading.role',
    SELECT_ROLE: 'organizations.selectRole',
    TABLE_EMPTY_USERS: 'organizations.tableEmptyUsers',
    TITLE: 'organizations.title',
    SUB_TITLE: 'organizations.subTitle',
    UPDATE_SUCCESS: 'common.success.updated',
    UPDATE_USER_SUCCESS: 'organizations.usersPatchSuccess',
    USERS_INVITES: 'organizations.usersInvites',
    TRANSFER_CREDITS_LINK: 'organizations.transferCredits',
    TRANSFER_CREDITS_TITLE: 'organizations.transferCredits',
    TRANSFER_CREDITS_ORGANIZATION_SOURCE:
      'organizations.transferCredits.organizationSource',
    TRANSFER_CREDITS_ORGANIZATION_TARGER:
      'organizations.transferCredits.organizationTarget',
    TRANSFER_CREDITS_CREDIT_TYPE: 'organizations.transferCredits.creditType',
    TRANSFER_CREDITS_AMOUNT: 'organizations.transferCredits.amount',
    TRANSFER_CREDITS_SUCCESS: 'organizations.transferCredits.success',
  },
  USER_PAGES: {
    ADMIN_COLOR: 'admin.color',
    ADMIN_LOGO: 'admin.logo',
    ADMIN_TITLE: 'admin.title',
    PROFILE_ACTION: 'profile.action',
    PROFILE_IMAGE: 'profile.image',
    PROFILE_PERSONAL_DATA: 'profile.personalData',
  },
  FORMS_PAGES: {
    TITLE: 'forms.title',
    NEW_FORM: 'forms.newForm',
    EDIT_TITLE: 'forms.editTitle',
    USE_FORM: 'forms.useForm',
    NO_SIGNERS: 'forms.noSigners',
    SIGN_TITLE: 'forms.signTitle',
  },
  INVITES: {
    STATUS_CODE_409: 'invites.error.409',
    STATUS_CODE_429: 'invites.error.429',
  },
  CREDIT_TYPES: {
    docs: 'creditTypes.docs',
    kyc: 'creditTypes.kyc',
    timestamps: 'creditTypes.timestamps',
    ine: 'creditTypes.ine',
    curp: 'creditTypes.curp',
    rfc: 'creditTypes.rfc',
    rfc_certs: 'creditTypes.rfc_certs',
    rfc_69b: 'creditTypes.rfc_69b',
  },
  SECURITY: {
    IDLE_TIMEOUT_UPDATED: 'security.idleTimeoutUpdated',
    IDLE_TIMEOUT_DESCRIPTION: 'security.idleTimeoutDescription',
    IDLE_TIMEOUT_5M: 'security.idleTimeout_300s',
    IDLE_TIMEOUT_20M: 'security.idleTimeout_1200s',
    IDLE_TIMEOUT_1H: 'security.idleTimeout_3600s',
    IDLE_TIMEOUT_2H: 'security.idleTimeout_7200s',
    IDLE_TIMEOUT_4H: 'security.idleTimeout_14400s',
    IDLE_TIMEOUT_8H: 'security.idleTimeout_28800s',
    IDLE_TIMEOUT_HINT: 'security.idleTimeoutHint',
    TITLE: 'security.title',
  },
  BRANDING: {
    PERSONAL_TITLE: 'branding.personal.title',
    PERSONAL_DESCRIPTION: 'branding.personal.description',
    TEAM_TITLE: 'branding.team.title',
    TEAM_DESCRIPTION: 'branding.team.description',
    PROFILE_IMAGE: 'branding.profile_image',
    AVATAR: 'branding.avatar',
    AVATAR_TOOLTIP: 'branding.generate_tooltip',
    JOB_LABEL: 'branding.job_label',
    TEAM_NAME_LABEL: 'branding.team_name_label',
    BRAND_COLOR: 'branding.brand_color',
    LOGOS: 'branding.logos',
    LOGO_DARK: 'branding.logo_dark',
    LOGO_DARK_HINT: 'branding.logo_dark_hint',
    LOGO_LIGHT: 'branding.logo_light',
    LOGO_LIGHT_HINT: 'branding.logo_light_hint',
    UPLOAD: 'branding.upload',
    INTERACTIVE_PREVIEW: 'branding.interactive_preview',
    SIDEBAR_PREVIEW: 'branding.sidebar_preview',
    USER_MENU_PREVIEW: 'branding.user_menu_preview',
    MEMBERS_LIST_PREVIEW: 'branding.members_list_preview',
    YOUR_PROFILE: 'branding.your_profile',
    YOUR_JOB: 'branding.your_job',
    EMOJI: 'branding.emoji',
    SELECT_TEAM: 'branding.select_team',
    LANGUAGE_LABEL: 'branding.language_label',
    EMAIL_HINT: 'branding.email_hint',
    WORKSPACE_TITLE: 'branding.workspace.title',
    WORKSPACE_DESCRIPTION: 'branding.workspace.description',
    WORKSPACE_SELECT: 'branding.workspace.select',
    WORKSPACE_EMPTY: 'branding.workspace.empty',
    WORKSPACE_SAVE: 'branding.workspace.save',
    IMAGE_SIZE_HINT: 'branding.image_size_hint',
    UPLOAD_IMAGE: 'branding.upload_image',
    GENERATE_TOOLTIP: 'branding.generate_tooltip',
  },
};
